// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"NavigationItem_navigationItem__ahLtJ","privateLink":"NavigationItem_privateLink__xtmEF","active":"NavigationItem_active__jpodC"};